import { createReducer, on } from '@ngrx/store';
import {
  hubspotLogin,
  hubspotLoginSuccess,
  hubspotLoginFailure,
  hubspotCallback,
  hubspotCallbackSuccess,
  hubspotCallbackFailure,
  hubspotLogout,
  hubspotLogoutSuccess,
  hubspotLogoutFailure,
  googleLogin,
  googleLoginSuccess,
  googleLoginFailure,
  googleCallback,
  googleCallbackSuccess,
  googleCallbackFailure,
  googleLogout,
  googleLogoutSuccess,
  googleLogoutFailure,
} from './oauth.actions';

export interface OAuthState {
  isConnectedToHubspot: boolean;
  isConnectedToGoogle: boolean;
  isConnectedToLivespace: boolean;
  error: string;
  isLoading: boolean;
  hs_object: any;
}

const initialState: OAuthState = {
  isConnectedToHubspot: false,
  isConnectedToGoogle: false,
  isConnectedToLivespace: false,
  error: null,
  isLoading: false,
  hs_object: null,
};

export const oauthReducer = createReducer(
  initialState,
  on(hubspotLogin, (state) => {
    return { ...state, isLoading: true, error: null };
  }),
  on(hubspotLoginSuccess, (state) => {
    return { ...state, isLoading: false, error: null };
  }),
  on(hubspotLoginFailure, (state, { error }) => {
    return { ...state, error, isLoading: false };
  }),
  on(hubspotCallback, (state) => {
    return { ...state, isLoading: true, error: null };
  }),
  on(hubspotCallbackSuccess, (state) => {
    return {
      ...state,
      isConnectedToHubspot: true,
      isLoading: false,
      error: null,
    };
  }),
  on(hubspotCallbackFailure, (state, { error }) => {
    return { ...state, error, isConnectedToHubspot: false, isLoading: false };
  }),

  on(hubspotLogout, (state) => {
    return { ...state, isLoading: true };
  }),
  on(hubspotLogoutSuccess, (state) => ({
    ...initialState,
  })),
  on(hubspotLogoutFailure, (state, { error }) => {
    return { ...state, error, isConnectedToHubspot: true, isLoading: false };
  }),

  on(googleLogin, (state) => {
    return { ...state, isLoading: true, error: null };
  }),
  on(googleLoginSuccess, (state) => {
    return { ...state, isLoading: false, error: null };
  }),
  on(googleLoginFailure, (state, { error }) => {
    return { ...state, error, isLoading: false };
  }),
  on(googleCallback, (state) => {
    return { ...state, isLoading: true, error: null };
  }),
  on(googleCallbackSuccess, (state) => {
    return {
      ...state,
      isConnectedToGoogle: true,
      isLoading: false,
      error: null,
    };
  }),
  on(googleCallbackFailure, (state, { error }) => {
    return { ...state, error, isConnectedToGoogle: false, isLoading: false };
  }),

  on(googleLogout, (state) => {
    return { ...state, isLoading: true };
  }),
  on(googleLogoutSuccess, (state) => ({
    ...initialState,
  })),
  on(googleLogoutFailure, (state, { error }) => {
    return { ...state, error, isConnectedToGoogle: true, isLoading: false };
  })
);
